import { defineStore } from 'pinia'

export const useRouterStore = defineStore('router', {
    persist: {
        enabled: false
    },
    state: () => {
        return {
            visitedViews: [],
            menus: [],
        }
    },
    actions: {
        addView(view) {
            if (this.visitedViews.some((v) => v.path === view.path)) return
            this.visitedViews.push({ ...view })
        },
        removeView(path) {
            const viewIndex = this.visitedViews.findIndex((v) => v.path === path);

            if (viewIndex > -1) {
                this.visitedViews.splice(viewIndex, 1)
            }
        },
        clearView() {
            this.visitedViews = []
        },
        setMenus(menus) {
            this.menus = menus
        },
    },
});